import type {
  ReportIllicitContentData,
  YesNoUnknown,
} from '~/api/care-platform/types/HelpCenterForms.types'

export const DANGEROUS_CATEGORY = 'dangerous_product'
export const RECALLED_CATEGORY = 'recalled_or_prohibited'

export const CONDITIONAL_CATEGORIES = [
  DANGEROUS_CATEGORY,
  RECALLED_CATEGORY,
] as const

export const CATEGORY_OPTION_VALUES = [
  'illegal_content',
  'counterfeit_or_ip_infringement',
  'misleading_advertising',
  'dangerous_product',
  'recalled_or_prohibited',
] as const satisfies readonly ReportIllicitContentData['category'][]

export const CAPACITY_OPTION_VALUES = [
  'individual',
  'company',
  'authority',
  'trusted_flagger',
  'rights_holder',
  'other',
] as const satisfies readonly ReportIllicitContentData['reporterCapacity'][]

export const RISK_NATURE_OPTION_VALUES = [
  'fire',
  'electric_shock',
  'suffocation',
  'chemical',
  'injury',
  'other',
] as const

export const YES_NO_UNKNOWN_OPTION_VALUES: YesNoUnknown[] = [
  'yes',
  'no',
  'unknown',
]

// Pragmatic format checks — the backend must still validate fully.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+$/
export const URL_REGEX = /^https?:\/\/[^\s]+$/

export const DESCRIPTION_MAX_LENGTH = 2000

// UaaS v2 upload settings.
export const EVIDENCE_UPLOAD = {
  serviceUploadBaseUrl: 'api/care-platform/external',
  useCase: 'care-illegal-content-report-attachment',
} as const
// Mirrors the use case `allowedFormats` (care-platform-config). The upload
// preset stays the security boundary: this only filters the file picker.
export const EVIDENCE_FILE_FORMATS = [
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'webp',
  'heic',
  'heif',
] as const
export const EVIDENCE_FILE_ACCEPT = EVIDENCE_FILE_FORMATS.map(
  (format) => `.${format}`,
)
export const MAX_EVIDENCE_FILES = 5
export const MAX_EVIDENCE_FILE_SIZE = 10 * 1024 * 1024

export const STEP_NAMES = {
  CONTENT: 'content',
  ABOUT: 'about',
  DECLARATION: 'declaration',
} as const

export const STEP_ORDER = [
  STEP_NAMES.CONTENT,
  STEP_NAMES.ABOUT,
  STEP_NAMES.DECLARATION,
] as const

export const STEP_FIELDS: Record<
  (typeof STEP_NAMES)[keyof typeof STEP_NAMES],
  Array<
    keyof import('./ReportIllicitContent.types').ReportIllicitContentFormValues
  >
> = {
  [STEP_NAMES.CONTENT]: [
    'category',
    'riskNature',
    'hasCausedIncident',
    'isSubjectToRecall',
    'description',
    'contentUrl',
  ],
  [STEP_NAMES.ABOUT]: ['reporterName', 'reporterEmail', 'capacity', 'country'],
  [STEP_NAMES.DECLARATION]: ['goodFaithCertified'],
}
